import React from "react";
import LdsLink from "../components/LdsLink";

const Logout = () => {
  return (
    <>
      <main className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-sm-12 col-md-6">
              <h1 className="blue text-uppercase b text-center">
                You have been logged out!
              </h1>
            </div>
          </div>
          <div className="row justify-content-center mt-4">
            <div className="col-sm-12 col-md-4">
              <div className="row">
                <div className="col-sm-12 col-md-6 offset-md-3">
                  <LdsLink
                    href="/login"
                    useIcon
                    icon="arrow-left"
                    iconOnly
                    contextualIcon
                    iconLabel="My Account"
                    iconPosition="before"
                    className="mt-5 d-block orange text-center"
                  >
                    Login again
                  </LdsLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Logout;
